module.exports = __webpack_public_path__ + "assets/img/组 94.25dc91ae.svg";